<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-card-multiple-outline"
          inline
          class="px-5 py-4 ml-0"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Valores dos Módulos ANEEL - {{$route.params.dataRef | formatToMonth}}
            </div>
          </template>
          <v-alert dense outlined type="info" color="blue" class="mb-3 mt-7 py-2 px-1">
            Essa página exibe no máximo 1000 registros.
            Caso queira visualizar os valores completos,<a id="link-modulos" @click="download()">clique aqui</a>
            para baixar os resultados em CSV.
          </v-alert>
          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefixText="Baixando Modulos Aneel"
          />
          <v-divider class="mt-10" />
          <v-data-table
            :headers="headers"
            :items="items"
            class="table-visualizar-modulos"
            :headerProps="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            :mobile-breakpoint="800"
            loading-text="Carregando..."
            no-data-text="Nenhum modulo encontrado"
            no-results-text="Nenhum registro correspondente encontrado"
          > 
            <template v-slot:[`item.COM_G1`]="{ item }">
              {{ getValue(item.COM_G1) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.COM_G2`]="{ item }">
              {{ getValue(item.COM_G2) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.COM_G3`]="{ item }">
              {{ getValue(item.COM_G3) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.COM_G4`]="{ item }">
              {{ getValue(item.COM_G4) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.COM_G5`]="{ item }">
              {{ getValue(item.COM_G5) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.CA_G1`]="{ item }">
              {{ getValue(item.CA_G1) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.CA_G2`]="{ item }">
              {{ getValue(item.CA_G2) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.CA_G3`]="{ item }">
              {{ getValue(item.CA_G3) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.CA_G4`]="{ item }">
              {{ getValue(item.CA_G4) | parseNumberToFloatBR}}
            </template>
            <template v-slot:[`item.CA_G5`]="{ item }">
              {{ getValue(item.CA_G5) | parseNumberToFloatBR}}
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ModulosAneelService from '@/services/ModulosAneelService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
import dayjs from 'dayjs';

  export default {
    mixins: [powerupsActionsMixins],
    
    components: {
      GeneralProgressBars: () => import("@/components/general/GeneralProgressBars.vue"),
    },

    data: () => ({
      items: [],
      loading:false,
      headers: [
        { text: 'Cod. Módulo', value: 'COD_MODULO' },
        { text: 'Módulo', value: 'DESCRICAO_MODULO' },
        { text: 'COM_G1', value: 'COM_G1' },
        { text: 'COM_G2', value: 'COM_G2' },
        { text: 'COM_G3', value: 'COM_G3' },
        { text: 'COM_G4', value: 'COM_G4' },
        { text: 'COM_G5', value: 'COM_G5' },
        { text: 'CA_G1', value: 'CA_G1' },
        { text: 'CA_G2', value: 'CA_G2' },
        { text: 'CA_G3', value: 'CA_G3' },
        { text: 'CA_G4', value: 'CA_G4' },
        { text: 'CA_G5', value: 'CA_G5' },
      ]
    }),

    mounted() {
      this.getModulosPreview();
    },
    
    methods: {
      getModulosPreview() {
        var data = this.$route.params.dataRef;
        var versao = this.$route.params.versao;
        ModulosAneelService.getModulosPreview(data, versao).then((response) => {
          this.items = response.data.data;
        })
        .catch(() => this.$toast.error('Erro ao buscar Modulos.', '', { position: 'topRight' }))
        .finally(() => this.loading = false);
      },

      getValue(value) {
        return value === null ? 0 : value;
      },

      download() {
        var data = { data:this.$route.params.dataRef, versao:this.$route.params.versao };
        const nomeArquivo = `Modulos Aneel versão ${data.versao} - ${dayjs(data.data).format('MM-YYYY')}.csv`;

        this.$set(this.downloadProgressData, data, { nomeArquivo }); 
        this.$toast.info("Preparando seu arquivo para download.", '', {position:'topRight', timeout: 2000});

        ModulosAneelService.download(data, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;

            this.$set(this.downloadProgressData, data, { progress, isComputable });
          }
        })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nomeArquivo);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Falha no download do Modulo.", "", { position: "topRight" });
          console.error("Error: ", err);
        })
        .finally(() => {
          this.$delete(this.downloadProgressData, data);
        });
      }
    }
  }
</script>

<style>
  .table-visualizar-modulos table tr td {
    font-size: 13px !important;
    font-weight: normal;
    color:rgb(63, 62, 60)
  }
  .table-visualizar-modulos table tr th {
    font-size: 13px !important;
    font-weight: bold !important;
  }
  .table-visualizar-modulos table tr th:nth-child(1) {
    width: 35px !important;
    min-width: 35px !important;
  }
  .table-visualizar-modulos table tr th:nth-child(1) span{
    white-space: pre-wrap !important;
  }
  #link-modulos{
    color: #E5502C;
    font-weight: bold;
    text-decoration: underline;
  }
</style>